/** Build / decode the `/requesters/:email` route segment. */

export function requesterPath(email: string): string {
    const trimmed = String(email || '').trim();
    if (!trimmed)
        return '/requesters';
    return `/requesters/${encodeURIComponent(trimmed)}`;
}

export function decodeRequesterEmailParam(raw?: string | null): string {
    if (!raw)
        return '';
    try {
        return decodeURIComponent(raw).trim();
    } catch {
        return String(raw).trim();
    }
}

export function requesterDomain(email: string): string {
    const at = email.lastIndexOf('@');
    if (at < 0 || at === email.length - 1)
        return '';
    return email.slice(at + 1).toLowerCase();
}
